module.exports = __webpack_public_path__ + "static/img/guanzi.0240f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/index/guanzi.png
// module id = VaSH
// module chunks = 86